export default __webpack_public_path__ + "static/media/loading.d48fe4e3.gif";